import { ImportData } from "components/hr-metrics/happiness-index/create/ImportData";
import { DEFAULT_FORM_HAPPINESS_INDEX, HAPPINESS_INDEX_VALIDATION, INITIAL_DATA_QUERY_HAPPINESS_INDEX_DETAIL } from "configs/hr-metrics/configTableHappinessIndexList";
import { ACTION_TYPE } from "constants/constant";
import { useValidation } from "hooks/useValidation";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { API_HAPPINESS_INDEX } from "services/apiHappinessIndex";
import { useFetch } from "services/useFetch";
import { getAllQueryParams, setQueryParams } from "utils/utils";

export const ImportDataContainer = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const [searchParams, setSearchParams] = useSearchParams()
    const periodId = searchParams.get('periodId')
    const query = searchParams.size > 0 ? getAllQueryParams(searchParams) : INITIAL_DATA_QUERY_HAPPINESS_INDEX_DETAIL
    const [form, setForm] = useState(DEFAULT_FORM_HAPPINESS_INDEX)
    const [isShowToast, setIsShowToast] = useState(false)
    const [toastMessage, setToastMessage] = useState('')
    const [modal, setModal] = useState({
        import: false,
        delete: false,
        edit: false,
        limit: false
    })
    const {data: detailList, fetching: getDetail, isLoading} = useFetch({...API_HAPPINESS_INDEX.DETAIL, initPathVariable: periodId}, INITIAL_DATA_QUERY_HAPPINESS_INDEX_DETAIL)    
    const {fetching: updateHappinessIndex, isLoading: isUpdating} = useFetch(API_HAPPINESS_INDEX.UPDATE)
    const {fetching: deleteHappinessIndex, isLoading: isDeleting} = useFetch(API_HAPPINESS_INDEX.DELETE)
    const {fetching: postHappinessIndex, isLoading: isLoadingSubmit} = useFetch(API_HAPPINESS_INDEX.SUBMIT)
    const { errorForm, isFormValid, validateForm } = useValidation({ form: form, schema: HAPPINESS_INDEX_VALIDATION })
    

    useEffect(() => {
        getDetail({...query})
    }, [location?.search])

    const onChangeQuery = (queryParams) => {
        const params = setQueryParams({...query, ...queryParams})
        setSearchParams(params, {replace: true})
    }

    const setShowModal = (value) => {
        setModal({...modal, ...value})
    }

    const clearToast = () => {
        setIsShowToast(false)
        setToastMessage('')
    }

    const showToast = (message) => {
        setIsShowToast(true)
        setToastMessage(message)
    }

    const onChangeForm = (e) => {
        const { name, value } = e
        setForm({ ...form, [name]: value })
    }

    const onHideImport = (refresh) => {
        setModal({...modal, import: false})
        if (refresh) getDetail()
    }

    const onClickItemHandler = ({item, actionType}) => {
        setForm(item)
        switch (actionType) {
            case ACTION_TYPE.EDIT:
                setShowModal({edit: true})
                break
            case ACTION_TYPE.DELETE:
                setShowModal({delete: true})
                break
            default:
                break
        }
    }

    const onDelete = () => {
        deleteHappinessIndex(null, form?.id)
            .then(() => {
                setModal({...modal, delete: false})
                showToast('Happiness Index Deleted !!')
                getDetail({...query})
            })
    }

    const onSubmitEdit = async () => {
        const {period, id, ...payload} = form
        await validateForm(payload)
        updateHappinessIndex(payload, id)
            .then(() => {
                setModal({...modal, edit: false})
                showToast('Happiness Index Updated !!')
                getDetail({...query})
            })
    }

    const onSubmit = () => {
        postHappinessIndex(null, periodId)
            .then(() => {
                showToast('Happiness Index Submitted !!')
                navigate('/human-resource-metrics/employee-happiness-index')
            }).catch(error => {
                if (error?.code === "400-AB004") {
                    navigate(`/human-resource-metrics/employee-happiness-index/detail-happiness-index?periodId=${periodId}`)
                }
            }) 
    }



    const props = {
        dataList: detailList?.data,
        isLoading,
        isDeleting,
        isUpdating,
        isLoadingSubmit,
        query,
        toast: {
            isShowToast,
            message: toastMessage
        },
        modal,
        form,
        errorForm,
        isFormValid: isFormValid(),
        onChangeQuery,
        setShowModal,
        clearToast,
        onChangeForm,
        onHideImport,
        onClickItemHandler,
        onDelete,
        onSubmitEdit,
        onSubmit,
    }

    return (
        <ImportData {...props}/>
    )
}
